<template>
  <v-dialog :value="value" width="800px" persistent>
    <v-card>
      <v-card-title>Program</v-card-title>
      <v-card-text class="black--text">
        <div>Introduction</div>
        <textarea
          :value="introduction"
          :style="{ border: '2px solid #000', width: '100%' }"
          rows="10"
          @input="introduction = $event.target.value"
        ></textarea>
        <div>Supernature Successes <span style="font-weight: 400; font-size: 12px">(one bullet per line, use **text** for bold)</span></div>
        <textarea
          :value="supernatureSuccesses"
          :style="{ border: '2px solid #000', width: '100%' }"
          rows="10"
          @input="supernatureSuccesses = $event.target.value"
        ></textarea>
      </v-card-text>
      <v-card-actions>
        <g-button label="Cancel" @onclick="close" />
        <div class="flex-grow-1"></div>
        <g-button label="Save" @onclick="save" />
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  props: {
    value: Boolean,
    data: Object,
  },
  data() {
    return {
      introduction: "",
      supernatureSuccesses: "",
    };
  },
  watch: {
    value(newValue) {
      if (newValue) {
        this.introduction = this.data?.program?.introduction || "";
        this.supernatureSuccesses = this.data?.program?.supernatureSuccesses || "";
      }
    },
  },
  methods: {
    close() {
      this.$emit("input", false);
    },
    save() {
      this.$emit("update", {
        introduction: this.introduction,
        supernatureSuccesses: this.supernatureSuccesses,
      });
      this.close();
    },
  },
};
</script>
